var $ = require("jquery"),
    RegionItem = require("./RegionMapItem.js"),
    RegionMap = require("./RegionMap.js"),
    GoogleMapAPI = require("utils/google-map-api");

module.exports = function (moduleHtmlElement) {

    var _self = this,
        $module = $(moduleHtmlElement),
        items = [],
        map = null,
        apiKey = "";

    _self.openItem = function (item) {
        for (var i = 0; i < items.length; i++) {
            if (items[i].isOpen() && items[i] !== item) {
                _self.closeItem(items[i]);
            }
        }
        item.open(map.getMap());
    };

    _self.closeItem = function (item) {
        item.close();
    };

    _self.closeAllItems = function () {
        for (var i = 0; i < items.length; i++) {
            _self.closeItem(items[i]);
        }
    };

    _self.getItems = function () {
        return items;
    };

    _self.getModuleHtmlElement = function () {
        return moduleHtmlElement;
    };

    var onResize = function () {
        onLayout();
    };

    var onLayout = function () {
        if (map === null) {
            GoogleMapAPI({
                apiKey: apiKey,
                onReady: function () {
                    map = new RegionMap(_self);
                }
            });
        }
        _self.closeAllItems();
    };

    var Constructor = function () {
        $('.o-region-map__item', $module).each(function () {
            items.push(new RegionItem(_self, this));
        });
        if ($module.attr('data-api-key')) {
            apiKey = $module.attr('data-api-key');
        }
        $(window).on("resize.regionmap-ctrl", onResize);
        onResize();
    };

    Constructor();
};


// WEBPACK FOOTER //
// ./Sig.Web/src/atomic/organism/o-region-map/RegionMapCtrl.js